{
  "familyId": "GELD-TERUGREKENEN",
  "questions": [
    {
      "id": "GELD-TERUGREKENEN-001",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een sportwinkel geeft 20% korting op hardloopschoenen. Na korting kosten ze €48. Hoeveel kostten de schoenen eerst?",
      "options": ["€57,60", "€38,40", "€60", "€68"],
      "correctAnswer": 2,
      "conceptId": "reverse_discount_20pct",
      "variantIndex": 1,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.percentage-van-nieuwe-prijs", "label": "Berekent percentage van nieuwe prijs", "optionIndex": 0 },
          { "id": "geld.dubbele-korting", "label": "Trekt korting dubbel af", "optionIndex": 1 },
          { "id": "geld.percentage-als-vast-bedrag", "label": "Telt percentage op als vast bedrag", "optionIndex": 3 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij korting",
            "content": "Na 20% korting betaal je 80% van de oude prijs (100% − 20% = 80%). Oude prijs = nieuwe prijs ÷ 0,80. Hier: €48 ÷ 0,80 = €60.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 20% korting betaal je 80% van de oude prijs (100% − 20% = 80%). Terugrekenen: €48 ÷ 0,80 = €60. Check: 20% van €60 = €12, en €60 − €12 = €48 ✓",
        "solutionSteps": [
          "Na 20% korting betaal je 80% van de oude prijs (100% − 20% = 80%)",
          "Oude prijs = €48 ÷ 0,80",
          "€48 ÷ 0,80 = €60",
          "Check: 20% van €60 = €12, €60 − €12 = €48 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt 20% van €48 erbij opgeteld (€48 + €9,60 = €57,60). Maar de korting was 20% van de OUDE prijs, niet van €48. Reken terug: €48 ÷ 0,80 = €60.",
          "1": "Je hebt de korting er nog een keer afgehaald. €48 is al de prijs ná korting. Reken terug: €48 ÷ 0,80 = €60.",
          "2": "Goed! €48 is 80% van de oude prijs. €48 ÷ 0,80 = €60.",
          "3": "Je hebt er €20 bij opgeteld. Maar 20% is niet hetzelfde als €20. Reken met percentages: €48 ÷ 0,80 = €60."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-002",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een fietsenmaker verhoogt de prijs van een reparatie met 10%. De nieuwe prijs is €132. Wat was de oude prijs?",
      "options": ["€118,80", "€120", "€145,20", "€122"],
      "correctAnswer": 1,
      "conceptId": "reverse_increase_10pct",
      "variantIndex": 2,
      "citoDifficulty": 0.43,
      "citoDiscrimination": 0.69,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.percentage-van-nieuwe-prijs", "label": "Berekent percentage van nieuwe prijs", "optionIndex": 0 },
          { "id": "geld.dubbele-verhoging", "label": "Telt verhoging dubbel op", "optionIndex": 2 },
          { "id": "geld.percentage-als-vast-bedrag", "label": "Trekt percentage af als vast bedrag", "optionIndex": 3 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij verhoging",
            "content": "Na 10% verhoging is de prijs 110% van het origineel (100% + 10% = 110%). Oude prijs = nieuwe prijs ÷ 1,10. Hier: €132 ÷ 1,10 = €120.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 10% verhoging is de prijs 110% van de oude prijs. Terugrekenen: €132 ÷ 1,10 = €120. Check: 10% van €120 = €12, €120 + €12 = €132 ✓",
        "solutionSteps": [
          "Na 10% verhoging betaal je 110% van de oude prijs",
          "Oude prijs = €132 ÷ 1,10",
          "€132 ÷ 1,10 = €120",
          "Check: 10% van €120 = €12, €120 + €12 = €132 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt 10% van de NIEUWE prijs afgetrokken (€132 − €13,20 = €118,80). Maar de verhoging was 10% van de OUDE prijs. Deel door 1,10: €132 ÷ 1,10 = €120.",
          "1": "Goed! €132 is 110% van de oude prijs. €132 ÷ 1,10 = €120.",
          "2": "Je hebt de nieuwe prijs nóg een keer met 10% verhoogd. Je moet juist terug: €132 ÷ 1,10 = €120.",
          "3": "Je hebt er €10 afgehaald. Maar 10% is niet altijd €10 — het hangt af van het bedrag. €132 ÷ 1,10 = €120."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-003",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Bij een speelgoedwinkel is een skateboard 25% afgeprijsd. Je betaalt nu €150. Reken terug: wat was de oude prijs?",
      "options": ["€187,50", "€112,50", "€250", "€200"],
      "correctAnswer": 3,
      "conceptId": "reverse_discount_25pct",
      "variantIndex": 3,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.67,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.percentage-van-nieuwe-prijs", "label": "Berekent percentage van nieuwe prijs", "optionIndex": 0 },
          { "id": "geld.dubbele-korting", "label": "Trekt korting dubbel af", "optionIndex": 1 },
          { "id": "geld.verkeerd-deelpercentage", "label": "Deelt door verkeerd percentage", "optionIndex": 2 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 25% korting",
            "content": "Na 25% korting betaal je 75% van de oude prijs. Oude prijs = €150 ÷ 0,75 = €200.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 25% korting betaal je 75% van de oude prijs (100% − 25% = 75%). Terugrekenen: €150 ÷ 0,75 = €200. Check: 25% van €200 = €50, €200 − €50 = €150 ✓",
        "solutionSteps": [
          "Na 25% korting betaal je 75% van de oude prijs",
          "Oude prijs = €150 ÷ 0,75",
          "€150 ÷ 0,75 = €200",
          "Check: 25% van €200 = €50, €200 − €50 = €150 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt 25% van €150 erbij opgeteld (€150 + €37,50). Maar de korting was 25% van de OUDE prijs. Deel door 0,75: €150 ÷ 0,75 = €200.",
          "1": "Je hebt de korting er nog een keer afgehaald. €150 is al de prijs ná korting. Deel door 0,75: €150 ÷ 0,75 = €200.",
          "2": "Je hebt gedeeld door 0,60 in plaats van 0,75. Bij 25% korting betaal je 75% van de oude prijs, niet 60%. Deel door 0,75: €150 ÷ 0,75 = €200.",
          "3": "Goed! €150 is 75% van de oude prijs. Terugrekenen: €150 ÷ 0,75 = €200."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-004",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "fill_in",
      "question": "Een boekwinkel geeft 10% korting. Een boek kost nu €36. Wat was de prijs vóór de korting? Typ je antwoord in euro's (bijv. 50).",
      "correctAnswer": "40",
      "data": {
        "acceptedAnswers": ["40", "€40", "40,00", "€40,00", "40.00"],
        "placeholder": "oude prijs in €",
        "inputType": "number"
      },
      "conceptId": "reverse_discount_10pct",
      "variantIndex": 4,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 3 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 10% korting",
            "content": "Na 10% korting betaal je 90% van de oude prijs. Oude prijs = €36 ÷ 0,90 = €40.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 10% korting betaal je 90% van de oude prijs. Terugrekenen: €36 ÷ 0,90 = €40. Check: 10% van €40 = €4, €40 − €4 = €36 ✓",
        "solutionSteps": [
          "Na 10% korting betaal je 90% van de oude prijs",
          "Oude prijs = €36 ÷ 0,90",
          "€36 ÷ 0,90 = €40",
          "Check: 10% van €40 = €4, €40 − €4 = €36 ✓"
        ]
      }
    },
    {
      "id": "GELD-TERUGREKENEN-005",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een kledingwinkel verhoogt de prijs van een winterjas met 20%. De jas kost nu €180. Wat betaalde je eerst?",
      "options": ["€216", "€144", "€150", "€160"],
      "correctAnswer": 2,
      "conceptId": "reverse_increase_20pct",
      "variantIndex": 5,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.68,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.percentage-van-nieuwe-prijs", "label": "Berekent percentage van nieuwe prijs", "optionIndex": 1 },
          { "id": "geld.dubbele-verhoging", "label": "Telt verhoging dubbel op", "optionIndex": 0 },
          { "id": "geld.percentage-als-vast-bedrag", "label": "Trekt percentage af als vast bedrag", "optionIndex": 3 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 20% verhoging",
            "content": "Na 20% verhoging is de prijs 120% van het origineel. Oude prijs = €180 ÷ 1,20 = €150.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 20% verhoging is de prijs 120% van de oude prijs. Terugrekenen: €180 ÷ 1,20 = €150. Check: 20% van €150 = €30, €150 + €30 = €180 ✓",
        "solutionSteps": [
          "120% = €180",
          "1% = €180 ÷ 120 = €1,50",
          "100% = €1,50 × 100 = €150",
          "Check: 20% van €150 = €30, €150 + €30 = €180 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt de nieuwe prijs nóg een keer met 20% verhoogd. Je moet juist terug: €180 ÷ 1,20 = €150.",
          "1": "Je hebt 20% van €180 afgetrokken (€180 − €36 = €144). Maar de verhoging was 20% van de OUDE prijs. Deel door 1,20.",
          "2": "Goed! Na 20% verhoging is €180 = 120% van de oude prijs. €180 ÷ 1,20 = €150.",
          "3": "Je hebt er €20 afgehaald. Maar 20% is niet hetzelfde als €20. Reken met percentages: €180 ÷ 1,20 = €150."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-006",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een dierenarts verhoogt de prijs van een behandeling met 25%. Je betaalt nu €45. Hoeveel kostte de behandeling eerst?",
      "options": ["€56,25", "€36", "€33,75", "€20"],
      "correctAnswer": 1,
      "conceptId": "reverse_increase_25pct",
      "variantIndex": 6,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.66,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.percentage-van-nieuwe-prijs", "label": "Berekent percentage van nieuwe prijs", "optionIndex": 2 },
          { "id": "geld.dubbele-verhoging", "label": "Telt verhoging dubbel op", "optionIndex": 0 },
          { "id": "geld.percentage-als-vast-bedrag", "label": "Gokt op veel te laag bedrag", "optionIndex": 3 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 25% verhoging",
            "content": "Na 25% verhoging is de prijs 125% van het origineel. Oude prijs = €45 ÷ 1,25 = €36.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 25% verhoging is de prijs 125% van de oude prijs. Terugrekenen: €45 ÷ 1,25 = €36. Check: 25% van €36 = €9, €36 + €9 = €45 ✓",
        "solutionSteps": [
          "125% = €45",
          "1% = €45 ÷ 125 = €0,36",
          "100% = €36",
          "Check: 25% van €36 = €9, €36 + €9 = €45 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt de nieuwe prijs nóg een keer met 25% verhoogd. Je moet juist terug: €45 ÷ 1,25 = €36.",
          "1": "Goed! Na 25% verhoging is €45 = 125% van de oude prijs. €45 ÷ 1,25 = €36.",
          "2": "Je hebt 25% van de nieuwe prijs afgetrokken. Maar de verhoging was 25% van de OUDE prijs. Deel door 1,25.",
          "3": "Dit bedrag is veel te laag. Onthoud: de oude prijs is altijd lager dan de verhoogde prijs, maar niet zó laag."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-007",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "In de uitverkoop bij een elektronicawinkel is een tablet 30% goedkoper. Je betaalt €105. Wat was de oude prijs van de tablet?",
      "options": ["€136,50", "€73,50", "€175", "€150"],
      "correctAnswer": 3,
      "conceptId": "reverse_discount_30pct",
      "variantIndex": 7,
      "citoDifficulty": 0.47,
      "citoDiscrimination": 0.67,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.percentage-van-nieuwe-prijs", "label": "Berekent percentage van nieuwe prijs", "optionIndex": 0 },
          { "id": "geld.dubbele-korting", "label": "Trekt korting dubbel af", "optionIndex": 1 },
          { "id": "geld.verkeerd-deelpercentage", "label": "Deelt door verkeerd percentage", "optionIndex": 2 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 30% korting",
            "content": "Na 30% korting betaal je 70% van de oude prijs. Oude prijs = €105 ÷ 0,70 = €150.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 30% korting betaal je nog 70% van de oude prijs (100% − 30% = 70%). Terugrekenen: €105 ÷ 0,70 = €150. Check: 30% van €150 = €45, €150 − €45 = €105 ✓",
        "solutionSteps": [
          "70% = €105",
          "10% = €15",
          "100% = €150",
          "Check: 30% van €150 = €45, €150 − €45 = €105 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt 30% van €105 erbij opgeteld (€105 + €31,50 = €136,50). Maar de korting was 30% van de OUDE prijs. Deel door 0,70.",
          "1": "Je hebt de korting er nog een keer afgehaald. €105 is al de prijs ná korting.",
          "2": "Je hebt gedeeld door 0,60 in plaats van 0,70. Bij 30% korting betaal je 70%, niet 60%. Deel door 0,70: €105 ÷ 0,70 = €150.",
          "3": "Goed! Na 30% korting betaal je 70% van de oude prijs. €105 ÷ 0,70 = €150."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-008",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "fill_in",
      "question": "Een muziekwinkel geeft 15% korting op een gitaar. De gitaar kost nu €68. Bereken de prijs vóór de korting. Typ je antwoord in euro's (bijv. 90).",
      "correctAnswer": "80",
      "data": {
        "acceptedAnswers": ["80", "€80", "80,00", "€80,00", "80.00"],
        "placeholder": "oude prijs in €",
        "inputType": "number"
      },
      "conceptId": "reverse_discount_15pct",
      "variantIndex": 8,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.68,
      "pedagogy": { "dok": 3 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 15% korting",
            "content": "Na 15% korting betaal je 85% van de oude prijs. Oude prijs = €68 ÷ 0,85 = €80.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 15% korting betaal je 85% van de oude prijs. Terugrekenen: €68 ÷ 0,85 = €80. Check: 15% van €80 = €12, €80 − €12 = €68 ✓",
        "solutionSteps": [
          "Na 15% korting betaal je 85% van de oude prijs",
          "Oude prijs = €68 ÷ 0,85",
          "€68 ÷ 0,85 = €80",
          "Check: 15% van €80 = €12, €80 − €12 = €68 ✓"
        ]
      }
    },
    {
      "id": "GELD-TERUGREKENEN-009",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een schoenenwinkelier prijst sneakers 20% af. Ze kosten nu €720. Hoeveel kostten ze vóór de actie?",
      "options": ["€576", "€900", "€864", "€960"],
      "correctAnswer": 1,
      "conceptId": "reverse_discount_20pct_large",
      "variantIndex": 9,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.69,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.percentage-van-nieuwe-prijs", "label": "Berekent percentage van nieuwe prijs", "optionIndex": 2 },
          { "id": "geld.dubbele-korting", "label": "Trekt korting dubbel af", "optionIndex": 0 },
          { "id": "geld.verkeerd-deelpercentage", "label": "Deelt door verkeerd percentage", "optionIndex": 3 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 20% korting",
            "content": "Na 20% korting betaal je 80% van de oude prijs. Oude prijs = €720 ÷ 0,80 = €900.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 20% korting betaal je 80% van de oude prijs. Terugrekenen: €720 ÷ 0,80 = €900. Check: 20% van €900 = €180, €900 − €180 = €720 ✓",
        "solutionSteps": [
          "80% = €720",
          "10% = €90",
          "100% = €900",
          "Check: 20% van €900 = €180, €900 − €180 = €720 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt de korting er nog een keer afgehaald. €720 is al de prijs ná korting.",
          "1": "Goed! Na 20% korting betaal je 80% van de oude prijs. €720 ÷ 0,80 = €900.",
          "2": "Je hebt 20% van €720 erbij opgeteld (€720 + €144 = €864). Maar de korting was 20% van de OUDE prijs.",
          "3": "Je hebt gedeeld door 0,75 in plaats van 0,80. Bij 20% korting betaal je 80%, niet 75%. Deel door 0,80: €720 ÷ 0,80 = €900."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-010",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "fill_in",
      "question": "Een zwemschool verhoogt het lesgeld met 10%. Het nieuwe bedrag is €264. Wat was het oude lesgeld? Typ je antwoord in euro's (bijv. 200).",
      "correctAnswer": "240",
      "data": {
        "acceptedAnswers": ["240", "€240", "240,00", "€240,00", "240.00"],
        "placeholder": "oud bedrag in €",
        "inputType": "number"
      },
      "conceptId": "reverse_increase_10pct_large",
      "variantIndex": 10,
      "citoDifficulty": 0.43,
      "citoDiscrimination": 0.69,
      "pedagogy": { "dok": 3 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 10% verhoging",
            "content": "Na 10% verhoging is de prijs 110% van het origineel. Oude prijs = €264 ÷ 1,10 = €240.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 10% verhoging is de prijs 110% van de oude prijs. Terugrekenen: €264 ÷ 1,10 = €240. Check: 10% van €240 = €24, €240 + €24 = €264 ✓",
        "solutionSteps": [
          "Na 10% verhoging betaal je 110% van de oude prijs",
          "Oude prijs = €264 ÷ 1,10",
          "€264 ÷ 1,10 = €240",
          "Check: 10% van €240 = €24, €240 + €24 = €264 ✓"
        ]
      }
    },
    {
      "id": "GELD-TERUGREKENEN-011",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Tijdens de opruiming bij een meubelzaak krijg je 40% korting. Je betaalt €120 voor een bureaustoel. Wat was de oude prijs?",
      "options": ["€168", "€72", "€240", "€200"],
      "correctAnswer": 3,
      "conceptId": "reverse_discount_40pct",
      "variantIndex": 11,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.66,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.percentage-van-nieuwe-prijs", "label": "Berekent percentage van nieuwe prijs", "optionIndex": 0 },
          { "id": "geld.dubbele-korting", "label": "Trekt korting dubbel af", "optionIndex": 1 },
          { "id": "geld.verkeerd-deelpercentage", "label": "Deelt door verkeerd percentage", "optionIndex": 2 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 40% korting",
            "content": "Na 40% korting betaal je 60% van de oude prijs. Oude prijs = €120 ÷ 0,60 = €200.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 40% korting betaal je nog 60% van de oude prijs. Terugrekenen: €120 ÷ 0,60 = €200. Check: 40% van €200 = €80, €200 − €80 = €120 ✓",
        "solutionSteps": [
          "60% = €120",
          "1% = €2",
          "100% = €200",
          "Check: 40% van €200 = €80, €200 − €80 = €120 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt 40% van €120 erbij opgeteld (€120 + €48 = €168). Maar de korting was 40% van de OUDE prijs.",
          "1": "Je hebt de korting er nog een keer afgehaald. €120 is al de prijs ná korting.",
          "2": "Je hebt gedeeld door 0,50 in plaats van 0,60. Bij 40% korting betaal je 60%, niet 50%. Deel door 0,60: €120 ÷ 0,60 = €200.",
          "3": "Goed! Na 40% korting betaal je 60% van de oude prijs. €120 ÷ 0,60 = €200."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-012",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een bakker verhoogt de prijs van een taart met 50%. De taart kost nu €105. Hoeveel kostte de taart eerst?",
      "options": ["€70", "€157,50", "€52,50", "€55"],
      "correctAnswer": 0,
      "conceptId": "reverse_increase_50pct",
      "variantIndex": 12,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.68,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.dubbele-verhoging", "label": "Telt verhoging dubbel op", "optionIndex": 1 },
          { "id": "geld.percentage-van-nieuwe-prijs", "label": "Berekent percentage van nieuwe prijs", "optionIndex": 2 },
          { "id": "geld.percentage-als-vast-bedrag", "label": "Trekt percentage af als vast bedrag", "optionIndex": 3 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 50% verhoging",
            "content": "Na 50% verhoging is de prijs 150% van het origineel. Oude prijs = €105 ÷ 1,50 = €70.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 50% verhoging is de prijs 150% van de oude prijs. Terugrekenen: €105 ÷ 1,50 = €70. Check: 50% van €70 = €35, €70 + €35 = €105 ✓",
        "solutionSteps": [
          "150% = €105",
          "50% = €35",
          "100% = €70",
          "Check: 50% van €70 = €35, €70 + €35 = €105 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Na 50% verhoging is €105 = 150% van de oude prijs. €105 ÷ 1,50 = €70.",
          "1": "Je hebt de nieuwe prijs nóg een keer met 50% verhoogd. Je moet juist terug: €105 ÷ 1,50 = €70.",
          "2": "Je hebt de helft van de nieuwe prijs genomen. Maar 50% verhoging betekent niet dat de oude prijs de helft is. Deel door 1,50.",
          "3": "Je hebt er €50 afgehaald. Maar 50% is niet hetzelfde als €50. Reken met percentages."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-013",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een smartwatch is met 12% afgeprijsd bij een elektronicawinkel. Je betaalt nu €220. Reken terug naar de oude prijs.",
      "options": ["€246,40", "€193,60", "€250", "€275"],
      "correctAnswer": 2,
      "conceptId": "reverse_discount_12pct",
      "variantIndex": 13,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.67,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.percentage-van-nieuwe-prijs", "label": "Berekent percentage van nieuwe prijs", "optionIndex": 0 },
          { "id": "geld.dubbele-korting", "label": "Trekt korting dubbel af", "optionIndex": 1 },
          { "id": "geld.verkeerd-deelpercentage", "label": "Deelt door verkeerd percentage", "optionIndex": 3 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 12% korting",
            "content": "Na 12% korting betaal je 88% van de oude prijs. Oude prijs = €220 ÷ 0,88 = €250.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 12% korting betaal je 88% van de oude prijs. Terugrekenen: €220 ÷ 0,88 = €250. Check: 12% van €250 = €30, €250 − €30 = €220 ✓",
        "solutionSteps": [
          "88% = €220",
          "1% = €220 ÷ 88 = €2,50",
          "100% = €250",
          "Check: 12% van €250 = €30, €250 − €30 = €220 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt 12% van de nieuwe prijs erbij opgeteld. Maar de korting was 12% van de OUDE prijs. Deel door 0,88.",
          "1": "Je hebt de korting er nog een keer afgehaald. €220 is al de prijs ná korting.",
          "2": "Goed! Na 12% korting betaal je 88% van de oude prijs. €220 ÷ 0,88 = €250.",
          "3": "Je hebt gedeeld door 0,80 in plaats van 0,88. Bij 12% korting betaal je 88%, niet 80%. Deel door 0,88: €220 ÷ 0,88 = €250."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-014",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een tuincentrum verhoogt de prijs van een barbecue met 15%. De barbecue kost nu €230. Wat was de oude prijs?",
      "options": ["€264,50", "€200", "€195,50", "€215"],
      "correctAnswer": 1,
      "conceptId": "reverse_increase_15pct",
      "variantIndex": 14,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.65,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.dubbele-verhoging", "label": "Telt verhoging dubbel op", "optionIndex": 0 },
          { "id": "geld.percentage-van-nieuwe-prijs", "label": "Berekent percentage van nieuwe prijs", "optionIndex": 2 },
          { "id": "geld.percentage-als-vast-bedrag", "label": "Trekt percentage af als vast bedrag", "optionIndex": 3 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 15% verhoging",
            "content": "Na 15% verhoging is de prijs 115% van het origineel. Oude prijs = €230 ÷ 1,15 = €200.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 15% verhoging is de prijs 115% van de oude prijs. Terugrekenen: €230 ÷ 1,15 = €200. Check: 15% van €200 = €30, €200 + €30 = €230 ✓",
        "solutionSteps": [
          "115% = €230",
          "1% = €230 ÷ 115 = €2",
          "100% = €200",
          "Check: 15% van €200 = €30, €200 + €30 = €230 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt de nieuwe prijs nóg een keer met 15% verhoogd. Je moet juist terug: €230 ÷ 1,15 = €200.",
          "1": "Goed! Na 15% verhoging is €230 = 115% van de oude prijs. €230 ÷ 1,15 = €200.",
          "2": "Je hebt 15% van de nieuwe prijs afgetrokken. Maar de verhoging was 15% van de OUDE prijs. Deel door 1,15.",
          "3": "Je hebt er €15 afgehaald. Maar 15% van €200 = €30, niet €15."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-015",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een televisie is bij een actie 21% goedkoper geworden. Je betaalt nu €316. Hoeveel kostte de televisie vóór de actie?",
      "options": ["€382,36", "€249,64", "€450", "€400"],
      "correctAnswer": 3,
      "conceptId": "reverse_discount_21pct",
      "variantIndex": 15,
      "citoDifficulty": 0.53,
      "citoDiscrimination": 0.64,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.percentage-van-nieuwe-prijs", "label": "Berekent percentage van nieuwe prijs", "optionIndex": 0 },
          { "id": "geld.dubbele-korting", "label": "Trekt korting dubbel af", "optionIndex": 1 },
          { "id": "geld.verkeerd-deelpercentage", "label": "Deelt door verkeerd percentage", "optionIndex": 2 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 21% korting",
            "content": "Na 21% korting betaal je 79% van de oude prijs. Oude prijs = €316 ÷ 0,79 = €400.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 21% korting betaal je 79% van de oude prijs (100% − 21% = 79%). Terugrekenen: €316 ÷ 0,79 = €400. Check: 21% van €400 = €84, €400 − €84 = €316 ✓",
        "solutionSteps": [
          "79% = €316",
          "1% = €316 ÷ 79 = €4",
          "100% = €400",
          "Check: 21% van €400 = €84, €400 − €84 = €316 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt 21% van €316 erbij opgeteld. Maar de korting was 21% van de OUDE prijs. Deel door 0,79.",
          "1": "Je hebt de korting er nog een keer afgehaald. €316 is al de prijs ná korting.",
          "2": "Je hebt gedeeld door 0,70 in plaats van 0,79. Bij 21% korting betaal je 79%, niet 70%. Deel door 0,79: €316 ÷ 0,79 = €400.",
          "3": "Goed! Na 21% korting betaal je 79% van de oude prijs. €316 ÷ 0,79 = €400."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-016",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een campingwinkel geeft 35% korting op een tent. De tent kost nu €195. Bereken de oorspronkelijke prijs.",
      "options": ["€300", "€263,25", "€126,75", "€325"],
      "correctAnswer": 0,
      "conceptId": "reverse_discount_35pct",
      "variantIndex": 16,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.64,
      "pedagogy": { "dok": 3, "misconceptionTags": [
          { "id": "geld.percentage-van-nieuwe-prijs", "label": "Berekent percentage van nieuwe prijs", "optionIndex": 1 },
          { "id": "geld.dubbele-korting", "label": "Trekt korting dubbel af", "optionIndex": 2 },
          { "id": "geld.verkeerd-deelpercentage", "label": "Deelt door verkeerd percentage", "optionIndex": 3 }
        ] },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 35% korting",
            "content": "Na 35% korting betaal je 65% van de oude prijs. Oude prijs = €195 ÷ 0,65 = €300.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 35% korting betaal je 65% van de oude prijs (100% − 35% = 65%). Terugrekenen: €195 ÷ 0,65 = €300. Check: 35% van €300 = €105, €300 − €105 = €195 ✓",
        "solutionSteps": [
          "65% = €195",
          "1% = €195 ÷ 65 = €3",
          "100% = €300",
          "Check: 35% van €300 = €105, €300 − €105 = €195 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Na 35% korting betaal je 65% van de oude prijs. €195 ÷ 0,65 = €300.",
          "1": "Je hebt 35% van de nieuwe prijs erbij opgeteld. Maar de korting was 35% van de OUDE prijs. Deel door 0,65.",
          "2": "Je hebt de korting er nog een keer afgehaald. €195 is al de prijs ná korting.",
          "3": "Je hebt gedeeld door 0,60 in plaats van 0,65. Bij 35% korting betaal je 65%, niet 60%. Deel door 0,65: €195 ÷ 0,65 = €300."
        }
      }
    },
    {
      "id": "GELD-TERUGREKENEN-017",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "fill_in",
      "question": "Een kledingwinkel geeft 20% korting op een trui. De trui kost nu €56. Wat was de oude prijs? Typ je antwoord in euro's (bijv. 70).",
      "correctAnswer": "70",
      "data": {
        "acceptedAnswers": ["70", "€70", "70,00", "€70,00", "70.00"],
        "placeholder": "oude prijs in €",
        "inputType": "number"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij korting",
            "content": "Na 20% korting betaal je 80% van de oude prijs (100% − 20% = 80%). Oude prijs = €56 ÷ 0,80 = €70.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "reverse_discount_fill_in",
      "variantIndex": 17,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.67,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "Na 20% korting betaal je 80% van de oude prijs. Terugrekenen: €56 ÷ 0,80 = €70. Check: 20% van €70 = €14, €70 − €14 = €56 ✓",
        "solutionSteps": [
          "Na 20% korting betaal je 80% van de oude prijs",
          "Oude prijs = €56 ÷ 0,80",
          "€56 ÷ 0,80 = €70",
          "Check: 20% van €70 = €14, €70 − €14 = €56 ✓"
        ]
      }
    },
    {
      "id": "GELD-TERUGREKENEN-018",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "fill_in",
      "question": "Een sportschool verhoogt het abonnement met 15%. Het nieuwe bedrag is €69. Wat was het oude bedrag? Typ je antwoord in euro's (bijv. 60).",
      "correctAnswer": "60",
      "data": {
        "acceptedAnswers": ["60", "€60", "60,00", "€60,00", "60.00"],
        "placeholder": "oud bedrag in €",
        "inputType": "number"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij verhoging",
            "content": "Na 15% verhoging is de prijs 115% van het origineel. Oude prijs = €69 ÷ 1,15 = €60.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "reverse_increase_fill_in",
      "variantIndex": 18,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.66,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "Na 15% verhoging is de prijs 115% van de oude prijs. Terugrekenen: €69 ÷ 1,15 = €60. Check: 15% van €60 = €9, €60 + €9 = €69 ✓",
        "solutionSteps": [
          "Na 15% verhoging betaal je 115% van de oude prijs",
          "Oude prijs = €69 ÷ 1,15",
          "€69 ÷ 1,15 = €60",
          "Check: 15% van €60 = €9, €60 + €9 = €69 ✓"
        ]
      }
    },
    {
      "id": "GELD-TERUGREKENEN-019",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "ordering",
      "question": "Een fiets kost na 30% korting €210 bij de fietsenmaker. Zet de stappen om de oude prijs te berekenen in de juiste volgorde.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": [
          "Bepaal welk percentage de kortingsprijs is: 100% − 30% = 70%",
          "Schrijf de vergelijking op: 70% = €210",
          "Bereken 1%: €210 ÷ 70 = €3",
          "Bereken 100%: €3 × 100 = €300",
          "Check: 30% van €300 = €90. €300 − €90 = €210 ✓"
        ],
        "correctOrder": [0, 1, 2, 3, 4]
      },
      "conceptId": "reverse_discount_ordering_steps",
      "variantIndex": 19,
      "citoDifficulty": 0.54,
      "citoDiscrimination": 0.65,
      "pedagogy": { "dok": 3 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stappenplan terugrekenen",
            "content": "Bij terugrekenen werk je altijd in deze volgorde: 1) Bepaal het percentage van de nieuwe prijs, 2) Stel de vergelijking op, 3) Bereken 1%, 4) Bereken 100%, 5) Check je antwoord.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Bij terugrekenen volg je een vast stappenplan. Eerst bepaal je dat de kortingsprijs 70% is (100% − 30%). Dan stel je op: 70% = €210. Vervolgens bereken je 1%: €210 ÷ 70 = €3. Dan 100%: €3 × 100 = €300. Tot slot check je: 30% van €300 = €90, en €300 − €90 = €210 ✓.",
        "solutionSteps": [
          "70% = €210 (de kortingsprijs)",
          "1% = €210 ÷ 70 = €3",
          "100% = €3 × 100 = €300",
          "Check: 30% van €300 = €90, €300 − €90 = €210 ✓"
        ]
      }
    },
    {
      "id": "GELD-TERUGREKENEN-020",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "true_false_series",
      "question": "Zijn deze beweringen over terugrekenen bij percentages waar of onwaar?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "Een koptelefoon kost na 20% korting €80. De oude prijs was €80 ÷ 0,80 = €100.", "isTrue": true },
          { "text": "Een skateboard is 10% duurder geworden en kost nu €55. De oude prijs was €55 − €5,50 = €49,50.", "isTrue": false },
          { "text": "Een spelcomputer kost na 50% korting €60. De oude prijs was €60 + 50% = €90.", "isTrue": false },
          { "text": "Een fiets is 25% duurder geworden en kost nu €250. De oude prijs was €250 ÷ 1,25 = €200.", "isTrue": true }
        ]
      },
      "conceptId": "reverse_percentage_true_false",
      "variantIndex": 20,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.64,
      "pedagogy": { "dok": 3 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen: veelgemaakte fouten",
            "content": "De meest gemaakte fout: het percentage optellen bij of aftrekken van de nieuwe prijs. Dat klopt niet, want het percentage was berekend over de OUDE prijs. Altijd delen: kortingsprijs ÷ (1 − kortings%) of verhoogde prijs ÷ (1 + verhogings%).",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Stelling 1: Waar — €80 is 80% van het origineel, dus €80 ÷ 0,80 = €100. Stelling 2: Onwaar — je mag niet 10% van de NIEUWE prijs aftrekken. De verhoging was 10% van de OUDE prijs. Juist: €55 ÷ 1,10 = €50. Stelling 3: Onwaar — 50% van €60 optellen geeft €90, maar de korting was 50% van de OUDE prijs. Juist: €60 ÷ 0,50 = €120. Stelling 4: Waar — €250 ÷ 1,25 = €200.",
        "solutionSteps": [
          "Stelling 1: €80 ÷ 0,80 = €100 ✓ (Waar)",
          "Stelling 2: Fout! €55 ÷ 1,10 = €50, niet €49,50 (Onwaar)",
          "Stelling 3: Fout! €60 ÷ 0,50 = €120, niet €90 (Onwaar)",
          "Stelling 4: €250 ÷ 1,25 = €200 ✓ (Waar)"
        ]
      }
    },
    {
      "id": "GELD-TERUGREKENEN-021",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "step_solver",
      "question": "Een koptelefoon kost na 20% korting €56 bij een elektronicawinkel. Reken stap voor stap terug naar de oude prijs.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "stepSolver": {
          "context": "",
          "steps": [
            {
              "prompt": "Welk percentage van de oude prijs is €56? (100% − 20% = ...%)",
              "correctAnswer": "80",
              "acceptedAnswers": ["80", "80%", "80 %", "80 procent"],
              "hint": "Trek het kortingspercentage af van 100%"
            },
            {
              "prompt": "Hoeveel is 1%? (€56 ÷ 80 = ...)",
              "correctAnswer": "0,70",
              "acceptedAnswers": ["0,70", "0.70", "€0,70", "0,7", "0.7"],
              "hint": "Deel de kortingsprijs door het percentage"
            },
            {
              "prompt": "Wat is 100%? (de oude prijs in €)",
              "correctAnswer": "70",
              "acceptedAnswers": ["70", "€70", "70,00", "€70,00"],
              "hint": "Vermenigvuldig 1% met 100"
            }
          ],
          "showStepsProgressively": true
        }
      },
      "conceptId": "reverse_discount_step_solver",
      "variantIndex": 21,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.66,
      "pedagogy": { "dok": 3, "cognitiveLevel": "analysis" },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stappenplan terugrekenen",
            "content": "Stap 1: Bepaal het percentage (100% − korting%). Stap 2: Bereken 1% (prijs ÷ percentage). Stap 3: Bereken 100% (1% × 100). Hier: 80% = €56, 1% = €0,70, 100% = €70.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 20% korting is de prijs 80% van het origineel. Stap 1: 80% = €56. Stap 2: 1% = €56 ÷ 80 = €0,70. Stap 3: 100% = €0,70 × 100 = €70. Check: 20% van €70 = €14, €70 − €14 = €56 ✓",
        "solutionSteps": [
          "80% = €56 (de kortingsprijs)",
          "1% = €56 ÷ 80 = €0,70",
          "100% = €0,70 × 100 = €70",
          "Check: 20% van €70 = €14, €70 − €14 = €56 ✓"
        ]
      }
    },
    {
      "id": "GELD-TERUGREKENEN-022",
      "familyId": "GELD-TERUGREKENEN",
      "module": "Geld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "step_solver",
      "question": "Een hotelkamer is met 15% duurder geworden. De nieuwe prijs is €230. Reken stap voor stap terug naar de oude prijs.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "stepSolver": {
          "context": "",
          "steps": [
            {
              "prompt": "Welk percentage van de oude prijs is €230? (100% + 15% = ...%)",
              "correctAnswer": "115",
              "acceptedAnswers": ["115", "115%", "115 %", "115 procent"],
              "hint": "Tel het verhogingspercentage op bij 100%"
            },
            {
              "prompt": "Hoeveel is 1%? (€230 ÷ 115 = ...)",
              "correctAnswer": "2",
              "acceptedAnswers": ["2", "€2", "2,00", "€2,00", "2.00"],
              "hint": "Deel de nieuwe prijs door het percentage"
            },
            {
              "prompt": "Wat is 100%? (de oude prijs in €)",
              "correctAnswer": "200",
              "acceptedAnswers": ["200", "€200", "200,00", "€200,00"],
              "hint": "Vermenigvuldig 1% met 100"
            }
          ],
          "showStepsProgressively": true
        }
      },
      "conceptId": "reverse_increase_step_solver",
      "variantIndex": 22,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.67,
      "pedagogy": { "dok": 3, "cognitiveLevel": "analysis" },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stappenplan terugrekenen bij verhoging",
            "content": "Stap 1: Bepaal het percentage (100% + verhoging%). Stap 2: Bereken 1% (prijs ÷ percentage). Stap 3: Bereken 100% (1% × 100). Hier: 115% = €230, 1% = €2, 100% = €200.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 15% verhoging is de prijs 115% van het origineel. Stap 1: 115% = €230. Stap 2: 1% = €230 ÷ 115 = €2. Stap 3: 100% = €2 × 100 = €200. Check: 15% van €200 = €30, €200 + €30 = €230 ✓",
        "solutionSteps": [
          "115% = €230 (de verhoogde prijs)",
          "1% = €230 ÷ 115 = €2",
          "100% = €2 × 100 = €200",
          "Check: 15% van €200 = €30, €200 + €30 = €230 ✓"
        ]
      }
    }
  ]
}